const API = process.env.REACT_APP_BACKEND_URL;
let sent = 0;

const report = (message, stack) => {
  if (sent >= 5 || !API) return;
  sent += 1;
  const payload = JSON.stringify({
    message: String(message || '').slice(0, 500),
    stack: String(stack || '').slice(0, 2000),
    url: window.location.href,
    ua: navigator.userAgent,
    mem: navigator.deviceMemory || null,
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/client-logs`, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(`${API}/api/client-logs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, credentials: 'include', keepalive: true }).catch(() => {});
    }
  } catch { /* noop */ }
};

export function registerClientLogs() {
  window.addEventListener('error', (e) => report(e.message, e.error?.stack));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    report(r?.message || String(r), r?.stack);
  });
}
